/* eslint-disable camelcase */
import { SORT_ORDER, TFilterOptions } from '@evinced-private/ui-common';

import { CUSTOM_FIELDS_FILTER_PARAM_KEY } from 'src/apps/dashboard/constants/CustomFields';
import { IGetWebSdkTestsParams } from 'src/apps/dashboard/types/WebSdkDashboardServiceTypes';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionOperators,
	Wsdk_Test_RunsSortFields,
	Wsdk_Test_RunsSortOrder
} from 'src/common/types/graphql.generated';

import { DashboardWebSdkTestsQueryVariables } from '../Tests.generated';

const DAYS_AMOUNT_FILTER_PARAM_KEY = 'daysAmountFilter';

const testsSortFieldNamesMap: Record<string, Wsdk_Test_RunsSortFields> = {
	testName: Wsdk_Test_RunsSortFields.TestName,
	runTime: Wsdk_Test_RunsSortFields.RunTime,
	criticalIssues: Wsdk_Test_RunsSortFields.CriticalIssues,
	seriousIssues: Wsdk_Test_RunsSortFields.SeriousIssues,
	totalIssues: Wsdk_Test_RunsSortFields.TotalIssues,
	testPath: Wsdk_Test_RunsSortFields.TestPath,
	testDisplayName: Wsdk_Test_RunsSortFields.TestName
};

const testsSortOrderMap: Record<SORT_ORDER, Wsdk_Test_RunsSortOrder> = {
	[SORT_ORDER.ASC]: Wsdk_Test_RunsSortOrder.Ascending,
	[SORT_ORDER.DESC]: Wsdk_Test_RunsSortOrder.Descending
};

export const buildTestsQueryVariables = ({
	dateRange,
	pageSize,
	page,
	filterOptions,
	sort,
	isShowTestPath,
	labelsExcludedFromDashboard
}: IGetWebSdkTestsParams): DashboardWebSdkTestsQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<DashboardWebSdkTestsQueryVariables>({
		sortFieldsMap: testsSortFieldNamesMap,
		sortOrderMap: testsSortOrderMap
	});

	let sortFields;
	if (sort?.dataField === 'testDisplayName') {
		sortFields = isShowTestPath ? ['testPath', 'testName'] : ['testName'];
	}

	variablesBuilder.addPaginationParams(page, pageSize).addSortParam(sort, sortFields);

	variablesBuilder.addTupleFilterParam(
		CUSTOM_FIELDS_FILTER_PARAM_KEY,
		filterOptions as TFilterOptions,
		ConditionOperators.All
	);

	variablesBuilder.addConditionParam(DAYS_AMOUNT_FILTER_PARAM_KEY, dateRange);

	if (labelsExcludedFromDashboard && Object.keys(labelsExcludedFromDashboard).length > 0) {
		variablesBuilder.addNeTupleFilterParam(
			'customFieldsFilterExcludes' as keyof DashboardWebSdkTestsQueryVariables,
			labelsExcludedFromDashboard
		);
	}

	return variablesBuilder.getVariables();
};
